module.exports = __webpack_public_path__ + "img/search-icon.c2d90632.svg";